import React                     from 'react';
import { quantities as tooltip } from 'pu-data/Tooltips';
import Tooltip                   from './Tooltip';
import Label                     from './Label';
import TextInput                 from './TextInput';

const Qty = props => (
  <TextInput inputClassName="pcb-qty" {...props} />
);

const Quantities = (props) => {
  const { parameters, errorMessage } = props;
  const onChange = props.onChangeParameter;
  const name = 'quantities';
  const [qty1, qty2, qty3, qty4] = parameters[name]
  return (
    <div className="form-group">
      <Label label={props.label} required={props.required}/> <Tooltip id="qty-tooltip" title={props.tooltip}/>
      <div className="row">
        <div className="col-3">
          <Qty
            groupName={props.groupName}
            name={props.nameQty1}
            onChange={e => onChange('qty1', e.target.value)}
            value={qty1}/>
        </div>
        <div className="col-3">
          <Qty
            groupName={props.groupName}
            name={props.nameQty2}
            onChange={e => onChange('qty2', e.target.value)}
            value={qty2}/>
        </div>
        <div className="col-3">
          <Qty
            groupName={props.groupName}
            name={props.nameQty3}
            onChange={e => onChange('qty3', e.target.value)}
            value={qty3}/>
        </div>
        <div className="col-3">
          <Qty
            groupName={props.groupName}
            name={props.nameQty4}
            onChange={e => onChange('qty4', e.target.value)}
            value={qty4}/>
        </div>
      </div>
      <div id="error_qty" />
      {errorMessage}
    </div>
  );
};

Quantities.defaultProps = {
  required : true,
  label    : 'Quantities',
  nameQty1 : '',
  nameQty2 : '',
  nameQty3 : '',
  nameQty4 : '',
  tooltip,
  groupName: 'parameters[quantities]',
  layout: 'inline',
};

export default Quantities;
